import { Injectable, inject, signal } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { StorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class SessionStore {
    private SESSION_ID_KEY = 'SESSION_ID';
    private storageService = inject(StorageService);

    public sessionId = signal(null);

    public initSessionId(): void {
        const sessionId = this.storageService.get<string>(this.SESSION_ID_KEY) ?? null;
        if (sessionId !== null && sessionId?.length > 0) {
            this.sessionId.set(sessionId);
        } else {
            this.sessionId.set(uuidv4());
            this.storageService.set<string>(this.SESSION_ID_KEY, this.sessionId());
        }
    }

    public removeSessionId(): void {
        this.sessionId.set(null);
        this.storageService.remove(this.SESSION_ID_KEY);
    }

    public reset(): void {
        this.removeSessionId();
    }
}
